import { supabase } from './supabase.js';
import { openLightbox } from './lightbox.js';
import { getMediaType, mediaThumbHTML } from './media.js';

function ensureModal() {
    let m = document.getElementById('place-photos-modal');
    if (m) return m;
    m = document.createElement('div');
    m.id = 'place-photos-modal';
    m.className = 'place-photos-modal';
    m.innerHTML = `
        <div class="pp-window">
            <div class="pp-head">
                <h2 id="pp-title">Technické foto místa</h2>
                <button class="modal-close" type="button" id="pp-close">×</button>
            </div>
            <div id="pp-body" class="pp-grid"></div>
        </div>
    `;
    document.body.appendChild(m);
    const close = () => m.classList.remove('open');

    // Pomocná: lightbox je nad modálem – pokud je otevřený, ignorovat zavírací akce
    const lightboxOpen = () => document.getElementById('lightbox')?.classList.contains('open');

    m.querySelector('#pp-close').addEventListener('click', close);
    m.addEventListener('click', (e) => {
        if (e.target === m && !lightboxOpen()) close();
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && m.classList.contains('open') && !lightboxOpen()) close();
    });
    return m;
}

export async function openPlacePhotos(placeId, placeName) {
    const modal = ensureModal();
    modal.querySelector('#pp-title').textContent = `Technické foto · ${placeName || 'místo'}`;
    const body = modal.querySelector('#pp-body');
    body.innerHTML = '<div class="pp-empty">Načítám…</div>';
    modal.classList.add('open');

    const { data, error } = await supabase
        .from('photos')
        .select('*')
        .eq('type', 'tech')
        .eq('place_id', placeId)
        .order('uploaded_at', { ascending: false });

    if (error) {
        body.innerHTML = `<div class="pp-empty" style="color:var(--accent);">Chyba: ${error.message}</div>`;
        return;
    }
    if (!data || data.length === 0) {
        body.innerHTML = '<div class="pp-empty">Zatím žádná technická fotka pro toto místo.</div>';
        return;
    }

    // Generate signed URLs in parallel
    const urls = await Promise.all(data.map(async p => {
        const { data: u } = await supabase.storage.from('photos-tech').createSignedUrl(p.storage_path, 3600);
        return u?.signedUrl || null;
    }));

    body.innerHTML = '';
    // Pole pro navigaci v lightboxu
    const photoArr = data
        .map((p, idx) => urls[idx] ? ({
            url: urls[idx],
            filename: p.storage_path.split('/').pop(),
            bucket: 'photos-tech',
            path: p.storage_path,
            photoId: p.id
        }) : null)
        .filter(Boolean);

    photoArr.forEach((photo, idx) => {
        const type = getMediaType(photo.path);
        const wrap = document.createElement('div');
        wrap.style.cursor = 'pointer';
        wrap.style.position = 'relative';
        wrap.innerHTML = mediaThumbHTML({ url: photo.url, path: photo.path, mediaType: type });
        const inner = wrap.firstElementChild;
        if (inner) {
            inner.style.width = '200px';
            inner.style.height = '200px';
            inner.style.borderRadius = '6px';
        }
        wrap.addEventListener('click', () => {
            openLightbox({
                photos: photoArr, startIndex: idx,
                onDelete: () => openPlacePhotos(placeId, placeName)
            });
        });
        body.appendChild(wrap);
    });
}
